/* global axios */
import ApiClient from './ApiClient';

class BorderchatTrustedForwardersAPI extends ApiClient {
  constructor() {
    super('borderchat_trusted_forwarders', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(forwarders) {
    return axios.patch(this.url, { forwarders });
  }
}

export default new BorderchatTrustedForwardersAPI();
